import { z } from 'zod';

export const featureFlagsSchema = z.object({
  isNewWalletEnabled: z.boolean().catch(true),
});
